import { Heading } from "@ui/components/content/heading/Heading";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";
import { BenefitItem } from "./BenefitItem";
import { styles } from "./EccoClubCardsStyles";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";

const MemberBenefits = () => {
    const { getMultiple } = useMicrocopy();

    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.loyalty.joinTheClubDescription,
            CommonCMS.freeShipping,
            CommonCMS.loyalty.freeShippingDescription,
            CommonCMS.loyalty.exclusiveOffersTitle,
            CommonCMS.loyalty.exclusiveOffersDescription,
            CommonCMS.tryandBuy,
            CommonCMS.tryandBuyDescription,
            CommonCMS.loyalty.rewardsTitle,
            CommonCMS.loyalty.rewardsDescription,
        ]);
    })();

    const benefits = [
        {
            icon: <ECCOIcon size="2xl" name="truck" />,
            title: microcopies[CommonCMS.freeShipping],
            description: microcopies[CommonCMS.loyalty.freeShippingDescription],
        },
        {
            icon: <ECCOIcon size="2xl" name="returns" />,
            title: microcopies[CommonCMS.loyalty.exclusiveOffersTitle],
            description: microcopies[CommonCMS.loyalty.exclusiveOffersDescription],
        },
        {
            icon: <ECCOIcon size="2xl" name="tryandbuy" />,
            title: microcopies[CommonCMS.tryandBuy],
            description: microcopies[CommonCMS.tryandBuyDescription],
        },
        {
            icon: <ECCOIcon size="2xl" name="discounts" />,
            title: microcopies[CommonCMS.loyalty.rewardsTitle],
            description: microcopies[CommonCMS.loyalty.rewardsDescription],
        },
    ];

    return (
        <Box bg="white" paddingY={5} px={[3, 6]}>
            <Heading as="h3" fontSize="lg" mb={6} textAlign="left">
                {microcopies[CommonCMS.loyalty.memberOnlyBenefits]}
            </Heading>
            <Flex
                flexDirection={{ base: "column", md: "row" }}
                justifyContent="space-between"
                alignItems="stretch"
            >
                {benefits.map((benefit, index) => (
                    <Box
                        key={index}
                        flex="1"
                        borderRight={{
                            base: "none",
                            md: index !== benefits.length - 1 ? "1px solid gray" : "none", // No border for the last item
                        }}
                        style={styles.memberOnlybenefitsItemContainer}
                    >
                        <BenefitItem
                            icon={benefit.icon}
                            title={benefit.title}
                            description={benefit.description}
                        />
                    </Box>
                ))}
            </Flex>
        </Box>
    );
};

export default MemberBenefits;
